const MAX_ENTRY_TITLE_LENGTH = 200;

interface EntryTitleInputProps {
    value: string;
    onChange: (value: string) => void;
    disabled: boolean;
}

// Optional per-interaction title, composer-only - the create page's thread
// title already covers the first interaction.
export function EntryTitleInput({ value, onChange, disabled }: EntryTitleInputProps) {
    return (
        <input
            type="text"
            value={value}
            maxLength={MAX_ENTRY_TITLE_LENGTH}
            disabled={disabled}
            onChange={(e) => onChange(e.target.value)}
            placeholder="Add a headline (optional)"
            className="w-full p-0 border-0 bg-transparent text-[20px] font-bold text-gray-900 placeholder-gray-400 placeholder:font-medium focus:outline-none focus:ring-0 disabled:opacity-50"
        />
    );
}
